
<link rel="stylesheet" type="text/css" href="https://pixinvent.com/stack-responsive-bootstrap-4-admin-template/app-assets/fonts/simple-line-icons/style.min.css">
<link href="https://fonts.googleapis.com/css?family=Montserrat&display=swap" rel="stylesheet">

<div class="container-fluid"> 
  <section id="stats-subtitle">
  <div class="row">
    <div class="col-xl-6 col-md-12">
      <div class="card overflow-hidden" style="background-color: #F5F7FA;">
        <div class="card-content">
          <div class="card-body cleartfix">
            <div class="media align-items-stretch">
              <div class="align-self-center">
                <i class="icon-pencil primary font-large-2 mr-2" style="color:#274C9C !important"></i>
              </div>
              <div class="media-body">
                <h4>Activity Time Elapsed</h4>
                <span>Total time elapsed from assignment</span>
              </div>
              <div class="align-self-center">
                <h1>18 hours</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-6 col-md-12">
      <div class="card" style="background-color: #F5F7FA;">
        <div class="card-content">
          <div class="card-body cleartfix">
            <div class="media align-items-stretch">
              <div class="align-self-center">
                <i class="icon-speech warning font-large-2 mr-2" style="color:#274C9C !important"></i>
              </div>
              <div class="media-body">
                <h4>Total Assigned</h4>
                <span>Number of assigned activities to: Bongani Maseko</span>
              </div>
              <div class="align-self-center"> 
                <h1>12</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
        <div class="col-sm-6">
            <div>
                <label>
                    <strong>Select User To Assign: </strong>
                </label>
                <select class="form-control form-control-sm" style="min-width: 100%"
                    [(ngModel)]="selectedUser">
                    <option *ngFor="let user of roleUsers" [ngValue]="user.UserID">{{user.Name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="col-sm-12" style="margin-top: 30px">
            <button class="btn hd-btn-close" style="float: right" (click)="onCancel()">Cancel</button>
            <button class="btn hd-btn" style="float: right" (click)="onProceed()" >Proceed</button>
        </div>
    </div>
</div>

</section>
</div>